import { Link } from "react-router-dom";

export function Diary({ diary }) {
  return (
    <article className="box">
      <div className="columns">
        <div className="column">
          <h5>
            <Link to={`/diaries/${diary.id}`}>
              {diary.title}
            </Link>
          </h5>
          <div className="column">
            <p>
              {diary.content}
            </p>
        </div>
        </div>
      </div>
    </article>
  );
}
